export default __webpack_public_path__ + "_/images/bonuses/bonuses-card/coin-deposit-1742b4d41f292b26e25640ecc92d55b76f769c82170211fe1a0a67b2896ed2bf.png";